import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './NavigationButtons.css'; // Optional

const allButtons = {
  learn: {
    label: "📘 Learn Some Signs!",
    route: "/learn",
    className: "learn",
  },
  games: {
    label: "🎮 Play a Sign Game",
    route: "/games",
    className: "game",
  },
  tools: {
    label: "🔍 Sign Lookup Tool",
    route: "/tools",
    className: "tools",
  },
  know: {
    label: "💡 Be a Sign Buddy!",
    route: "/info",
    className: "know",
  },
  practice: {
    label: "📷 Try Signing Yourself!",
    route: "/practice",
    className: "practice",
  },
  simulator: {
    label: "🧠 Deaf Experience Simulator",
    route: "/simulator",
    className: "simulator",
  },
};

const pageButtonsMap = {
  "/learn": ["practice", "tools"],
  "/games": ["practice", "simulator"],
  "/tools": ["games", "simulator"],
  "/info": ["learn", "simulator"],
  "/practice": ["learn", "games"],
  "/simulator": ["know", "learn"],
};

export default function NavigationButtons() {
  const navigate = useNavigate();
  const location = useLocation();

  const buttonsToShow = pageButtonsMap[location.pathname] || [];

  return (
    <div className="navigation-buttons">
      {buttonsToShow.map((key) => {
        const { label, route, className } = allButtons[key];
        return (
          <button key={key} className={className} onClick={() => navigate(route)}>
            {label}
          </button>
        );
      })}
    </div>
  );
}

